export const sceneNumbers = {
	initMainMenu: 0,
	initIntroduction: 1,
	tema4SubtopicOne: 2,
	tema4SubtopicTwo: 3,
	tema4SubtopicThree: 4,
	tema4SubtopicFour: 5,
	tema4SubtopicFive: 6,
	tema4SubtopicSix: 7,
};
